import _ from 'lodash';
import template from 'url-template';

import {
    FETCH_CLIENTS,
    SET_CLIENT
} from './actionTypes';

import awsHeader from '../helpers/awsAuth';
import k2aBaseApi from '../apis/key2act';

import { handleNetworkError } from './applicationMessageActions';

const CompaniesUrl = template.parse('/companies/{companyId}/clients{?limit,page}');
const ClientUrl = template.parse('/clients/{clientId}');

const DEFAULT_PAGE_LIMIT = 100;

export const fetchInitialClients = (companyId, options = {}) => async dispatch => {
    const header = await awsHeader();

    options.limit || (options.limit = DEFAULT_PAGE_LIMIT);

    try {
        const response = await k2aBaseApi.get(
            CompaniesUrl.expand({
                companyId,
                ...options
            }),
            header
        );

        const payload = _.get(response, 'data.data', []);

        dispatch({
            type:    FETCH_CLIENTS,
            payload: _prepareClient(payload)
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};

export const setClient = client => ({
    type:    SET_CLIENT,
    payload: client
});

const _prepareClient = payload => payload.map(client => ({
    address: client.address,
    id:      client.id,
    label:   client.name,
    name:    client.name,
    value:   client.id
}));

export const fetchClientById = (clientId, options = {}) => async dispatch => {
    const header = await awsHeader();

    options.limit || (options.limit = DEFAULT_PAGE_LIMIT);

    try {
        const response = await k2aBaseApi.get(
            ClientUrl.expand({
                clientId,
                ...options
            }),
            header
        );

        const payload = _.get(response, 'data.data', []);

        dispatch({
            type:    FETCH_CLIENTS,
            payload: _prepareClient(payload)
        });
    } catch (error) {
        dispatch(handleNetworkError(error));
    }
};
